import {LocationDetailsResponse} from 'src/app/shared/models/LocationDetailsResponse.model';
import {CountryModel} from 'src/app/shared/models/CountryModel';
import BeneficiaryEntityType from 'src/app/shared/enums/BeneficiaryEntityType.enum';
import {CurrencyModel} from 'src/app/shared/models/CurrencyModel';
import {InvestingEntityReqRes} from './InvestingEntityReqRes.model';
import {PaymentType} from 'src/app/shared/enums/payment-type.enum';
import CheckingOrSavingsType from '../../shared/enums/CheckingOrSavingsType.enum';
import { AccountConnectedStatus } from '../bankAccounts/enums/accountConnectedStatus.enum';

export class ClientBankAccountResponseBasic {
  public id: number;
  public nickname: string;
  public holderFullName: string;
  public countryId: number;
  public country: CountryModel;
  public isModifiable: boolean;
  public isMissingGpData: boolean;
  public organizationDetailsId: number;
  public clientDetailsId: number;
  public accountNumber: string;
  public usabaRoutingNumber: string;
  public fedWireRoutingNumber: string;
  public isUnitBankAccount: boolean;
  public paymentType: PaymentType;
  public connectedStatus: AccountConnectedStatus;
  public mask: string;
}

export class ClientBankAccountReqRes extends ClientBankAccountResponseBasic {
  public isAnOrganizationAccount: boolean;
  public bankAccountType: string;
  public holderLocationDetails: LocationDetailsResponse;
  public holderLocationDetails_Id: number;
  public holderLocalizedFullName: string;
  public bankCode: string;
  public bankName: string;
  public bankBranchCode: string;
  public bankBranchName: string;
  public internalIsApproved: boolean;
  public internalRemarks: string;
  public swift: string;
  public bsb: string;
  public canadaInstitutionNumber: string;
  public canadaTransitNumber: string;
  public ifsc: string;
  public iban: string;
  public bankAccountData: string;
  public ukSortCode: string;
  public beneficiaryEntityType: BeneficiaryEntityType;
  public beneficiaryTin: string;
  public preferredCurrencyId: number;
  public preferredCurrency: CurrencyModel;
  public investingEntityId: number;
  public investingEntity: InvestingEntityReqRes;
  public isCreatedByAgent: boolean;
  public holdingNames: string;
  public isDefault: boolean;
  public setForAllHoldings: boolean;
  public memo: string;
  public checkingOrSavingsType: CheckingOrSavingsType;
}
